import { createContext } from 'react';

const useProductUtilizationDashboardContext = createContext();

export default useProductUtilizationDashboardContext;
